import {Suspense, lazy} from 'react'
import Loader from "../customs/loader/main"

const Main = lazy(() => import("../components/needHelp/main"))

const NeedHelp = () => {
  return (
    <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
  )
}

export default NeedHelp